import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get("session_id");

        if (!sessionId) {
          console.error("No session_id found in URL");
          navigate("/login");
          return;
        }

        // Check if user agreed to terms (stored in sessionStorage from RegisterPage)
        const agreedToTerms = sessionStorage.getItem('agreed_to_terms') === 'true';
        // Clear the flag after reading
        sessionStorage.removeItem('agreed_to_terms');

        // Exchange session_id for our session
        const response = await axios.post(
          `${API}/api/auth/google/session`,
          { session_id: sessionId, agreed_to_terms: agreedToTerms },
          { withCredentials: true }
        );

        // Session is managed via httpOnly cookie - no localStorage needed

        // Redirect to calculator with user data
        navigate("/calculator", { 
          state: { user: response.data },
          replace: true 
        });
      } catch (error) {
        console.error("Auth callback error:", error);
        const message = error.response?.data?.detail || "Authentication failed";
        toast.error(message);
        // If pending approval, redirect to register page with info
        if (error.response?.status === 403) {
          navigate("/register", { replace: true });
        } else {
          navigate("/login", { replace: true });
        }
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto mb-4" />
        <p className="text-lg text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
}
